import apiFetch, { ApiFetchOptions, HTTPError } from 'react-scale/lib/api-fetch';

export async function taxonomyApiFetch<R = any, B = any>(
  url: string,
  options: ApiFetchOptions<B> = {},
): Promise<R> {
  try {
    return await apiFetch<R, B>(null, url, options);
  } catch (err) {
    if (err instanceof HTTPError) {
      // tryParseErrorResponse will always try to fill the 'message' key
      throw Error(err.response.message);
    } else {
      throw err;
    }
  }
}
